var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69.3 63.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ce82ff;\n      }\n\n      .cls-3 {\n        fill: #168dc5;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        opacity: .2;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.7,
    y: 13.7,
    width: 30,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 34.7,
    cy: 35.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 34.7,
    cy: 35.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 35.7 0 27.1 15 31.6 0 35.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.3 35.7 69.3 27.7 57.5 27.7 69.3 35.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 34.7,
    cy: 27.7,
    rx: 34.7,
    ry: 27.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.4,15.1c.9-1.9,3.6-1.9,4.5,0l2.6,5.4c.4.8,1.1,1.3,2,1.4l6,.7c2.1.2,3,2.9,1.4,4.3l-4.3,3.8c-.7.6-1,1.5-.8,2.4l1.1,5.6c.4,2.1-1.8,3.7-3.6,2.7l-5.4-2.9c-.7-.4-1.6-.4-2.4,0l-5.5,2.9c-1.9,1-4-.6-3.6-2.7l1.1-5.6c.2-.9-.1-1.8-.8-2.4l-4.3-3.8c-1.6-1.4-.8-4.1,1.4-4.3l6-.7c.8-.1,1.6-.6,2-1.4l2.6-5.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUp2);
export default __webpack_public_path__ + "static/media/button_up_2.7f92dec6bd744f7df7b34b402bb30209.svg";
export { ForwardRef as ReactComponent };